import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01146bb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formal-footer" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("申请审批")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("撤回申请")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重新发起")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("修改出纳、会计")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("回传")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("撤回回传")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("回传")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("撤回回传")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("补充资料申请")
const _hoisted_15 = {
  key: 12,
  class: "tips"
}

import { withDefaults, computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import { message } from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    typeList: { default: () => [] },
    showTips: { default: "" }
  },
  emits: ["click"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { typeList: (number | string)[], showTips: string }

const store = useStore();
const router = useRouter();
const route = useRoute();


const goback = () => {
  if (route.path.indexOf("process") != -1) {
    router.push("/processlist");
  } else {
    if (route.path.indexOf("open") >= 0) {
      window.location.reload();
    } else {
      router.go(-1);
    }
  }
};
const submit = function (type: number | string) {
  if (props.showTips && type == "100") {
    message.error(props.showTips);
    return;
  }
  $emit("click", type);
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_affix = _resolveComponent("a-affix")!

  return (_openBlock(), _createBlock(_component_a_affix, { "offset-bottom": 0 }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.typeList, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (item == 90)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: goback,
                    class: "btn-back btn",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (item == 100)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    size: "large",
                    class: _normalizeClass(["btn btn-back", __props.showTips ? 'disalbe' : '']),
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]))
                : _createCommentVNode("", true),
              (item == 101)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    type: "primary",
                    size: "large",
                    class: "btn btn-back",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 102)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 3,
                    type: "primary",
                    size: "large",
                    class: "btn btn-back",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 103 || item == 105)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 4,
                    type: "primary",
                    size: "large",
                    class: "btn btn-back",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 104)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 5,
                    type: "primary",
                    size: "large",
                    danger: "",
                    onClick: ($event: any) => (submit(item)),
                    class: "btn btn-reject btn-back"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 106)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 6,
                    type: "primary",
                    size: "large",
                    class: "btn btn-back btn-edit",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 201)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 7,
                    type: "primary",
                    size: "large",
                    class: "btn btn-back",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 202)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 8,
                    type: "primary",
                    class: "btn btn-back",
                    size: "large",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 301)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 9,
                    type: "primary",
                    class: "btn",
                    size: "large",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 302)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 10,
                    type: "primary",
                    size: "large",
                    class: "btn btn-back",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (item == 303)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 11,
                    type: "primary",
                    size: "large",
                    class: "btn btn-back",
                    onClick: ($event: any) => (submit(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (__props.showTips && __props.typeList.includes('100'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(__props.showTips), 1))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})